import Leads from "./components/KingsApplication";

export default Leads;
